import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("khn_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("khn_token"); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, captcha_token = "") => {
    try {
      const { data } = await api.post("/auth/login", { email, password, captcha_token });
      localStorage.setItem("khn_token", data.token);
      try { sessionStorage.removeItem("khn_dismissed_reminders"); } catch { /* ignore */ }
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("khn_token");
    try { sessionStorage.removeItem("khn_dismissed_reminders"); } catch { /* ignore */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
